<template>
  <div>
    <v-row
      v-for="(connect, i) in questionlist"
      :key="connect.questionID"
      :id="connect.questionID"
    >
      <v-col cols="12" v-show="NoQuestionSearch.length !== 0 && connect.show">
        <v-card>
          <QuestionLabel
            ref="connect"
            type="connect"
            :label="connect"
            :visible="connect.show"
            :index="i"
            :questionlist="questionlist"
            :JumpQuestion="JumpQuestion"
            :NextQuestion="NextQuestion(i)"
            :surveyStatus="surveyStatus"
          >
            <template v-slot:moveto>
              <SwapButton
                :connect="connect"
                :questionlist="questionlist"
                :JumpQuestion="JumpQuestion"
                :surveyStatus="surveyStatus"
              />
            </template>
          </QuestionLabel>
        </v-card>
      </v-col>
    </v-row>
    <v-card
      v-if="NoQuestionSearch.length === 0"
      class="d-flex justify-center py-2"
    >
      ไม่พบคำถามที่เกี่ยวข้องกับการค้นหา
    </v-card>
    <v-row class="my-8">
      <v-col cols="12" class="d-flex justify-center">
        <v-btn
          color="primary"
          small
          dark
          fab
          @click.stop="BeforeAdd"
          v-show="QPermission.question.create"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <span>เพิ่ม Question</span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="questionname"
                  label="Question name"
                  outlined
                  @keydown.enter.prevent
                  :rules="[$store.getters.TextRule(questionname)]"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0278ae" outlined @click="ClosePopupAdd">
                  ยกเลิก
                </v-btn>
                <v-btn color="#0278ae" dark @click="AddQuestionLabel">
                  บันทึก
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import QuestionLabel from "./QuestionLabel";
import SwapButton from "./SwapButton.vue";
export default {
  props: ["questionlist", "JumpQuestion", "surveyStatus"],
  components: { QuestionLabel, SwapButton },
  data() {
    return {
      dialog: false,
      showMenu: false,
      questionname: "",
    };
  },
  computed: {
    NoQuestionSearch() {
      return this.questionlist.filter((show) => show.show);
    },
    QPermission() {
      return this.$store.state.user_permission;
    },
    Editing() {
      return this.$store.state.editing;
    },
  },
  methods: {
    ClosePopupAdd() {
      this.dialog = false;
      this.questionname = "";
      this.$refs.form.resetValidation();
    },
    BeforeAdd() {
      if (this.Editing) {
        Swal.fire({
          title: "",
          text: `คุณมีการแก้ไข "${this.$store.state.editingPreData?.questionLabel}" ค้างไว้ กรุณาดำเนินการให้เรียบร้อย`,
          icon: "warning",
          confirmButtonText: "ตกลง",
          customClass: {
            popup: "format-pre",
          },
        }).then(() => {
          let vm = this;
          setTimeout(() => {
            vm.$store.commit("BacktoEditing");
          }, 300);
        });
      } else {
        this.PopupOpen();
      }
    },
    PopupOpen() {
      if (this.surveyStatus) {
        Swal.fire({
          title: `แบบสอบถามนี้ถูกเปิดการใช้งานแล้ว`,
          text: "การแก้ไขคำถามจะทำให้ความน่าเชื่อถือลดลงและผู้ตอบแบบสอบถามจะได้รับคำถามที่ไม่เท่ากัน",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ปิด",
        }).then((result) => {
          if (result.isConfirmed) {
            this.dialog = true;
          }
        });
      } else {
        this.dialog = true;
      }
    },
    AddQuestionLabel() {
      if (this.$refs.form.validate()) {
        let data = {
          questionLabel: this.questionname,
          questionType: "connect",
          indexing:
            this.questionlist[this.questionlist.length - 1].indexing + 1,
          questions: [
            {
              type: "text",
              payload: {
                text: this.questionname,
              },
            },
          ],
          conditionType: "freetext",
          conditionsAnswer: {
            match: [
              {
                nextQuestionID: this.JumpQuestion.end[0].questionID,
                score: {},
                value: 0,
              },
            ],
            notmatch: {
              nextQuestionID: this.JumpQuestion.end[0].questionID,
              score: 0,
            },
            failCaseID: null,
          },
        };
        this.dialog = false;
        this.$store
          .dispatch("AddQuestionLabel", data)
          .then(() => {
            Swal.fire({
              icon: "success",
              text: `เพิ่ม ${this.questionname} สำเร็จ`,
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.questionname = "";
              this.$refs.form.resetValidation();
              // data.questionID = resp.data.questionID;
              // data.editable = false;
              // this.$store.state.allquestion.push(data);
              this.$store.dispatch("getQuestionLabel", this.$route.params);
            });
          })
          .catch((err) => {
            if (err.data.message === "Permission Denied") {
              Swal.fire({
                icon: "warning",
                text: "สิทธิ์ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                window.location.reload();
              });
            } else if (err.data.message === "Survey Not Avaliable.") {
              this.$store.commit("ToggleLoading");
            } else {
              Swal.fire({
                icon: "error",
                text: `ไม่สามารถเพิ่ม ${this.questionname} ได้`,
                title: "",
              });
            }
          });
      }
    },
    NextQuestion(i) {
      return this.questionlist[i + 1]
        ? this.questionlist[i + 1]
        : this.JumpQuestion.end[0];
    },
  },
};
</script>

<style lang="scss" scoped></style>
